// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__qfX73","header":"styles_header__n_n1M","row":"styles_row__bTL9Q"};